<template>
  <div class="dashboard">
    <Common />
    <div class="dashboard-container">
      <Sidebar />
      <TopBar />
      <Content />
    </div>
  </div>
</template>

<script>
import TopBar from '@/components/dashboard/TopBar.vue'
import Content from '@/components/dashboard/Content.vue'
import Sidebar from '@/components/dashboard/Sidebar.vue'
import Common from '@/components/common/Common.vue'
export default {
  name: 'DashboardLayout',
  components: { 
    TopBar, 
    Content,
    Sidebar,
    Common,
  },
}
</script>

<style lang="scss" scoped>
.dark-theme {
  .dashboard {
    > .dashboard-container {
      background-color: $black;
    }
  }
}
.dashboard {
  height: 100%;
  width: 100%;
  > .dashboard-container {
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas: 
      'sideBar            topBar'
      'sideBar            content'
    ;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background-color: $white;
    padding: 1rem;
    gap: 1rem;
  }
}
</style>